export enum InitializationSteps {
  NOT_INITIALIZED = 'NOT_INITIALIZED',
  SETUP_NEW_IDENTITY_MODULE = 'Setting up new identity',
  CHECK_AND_TRANSFER_OWNERSHIP = 'Checking and transferring ownership',
  UPDATE_KEYSTORE = 'Updating keystore',
  DEPLOY_PORTAL = 'Deploying portal',
}

export enum CheckAndTransferOwnershipSteps {
  NOT_INITIALIZED = 'NOT_INITIALIZED',
  REGISTER_NEW_OWNER_AS_COLLABORATOR = 'Registering new owner as collaborator',
  REGISTER_COLLABORATOR_KEYS = 'Registering collaborator keys',
  TRANSFER_OWNERSHIP = 'Transferring ownership',
  ACCEPT_OWNERSHIP = 'Accepting ownership',
}

export interface SetupModalState {
  isOpen: boolean;
  identityAlreadyExists: boolean;
}
